import React from 'react';

import {UnderConstruction} from './common/UnderConstruction';

export const TablePage: React.FC = () => {
  return (
    <UnderConstruction
      title="Table"
      message={<>This page will contain a specific table</>}
    />
  );
};
